(ns ycweb.app.website.dlp.widgets.mostgifted
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cards :as cards]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.util.core :as u]))

(rum/defc most-gifted < rum/reactive [app-atom _ {:keys [properties]}]
  (let [{:most-gifted/keys
         [title heading-type on-page-link-id columns
          show-viewmore-link? more-url products]} properties]
    [:div.yc-section
     {:id (when (u/presence on-page-link-id) on-page-link-id)}
     (when (u/presence title)
       (headings/heading title {:type (keyword (str "h" heading-type)) :size :default}))

     (when (u/presence products)
       (cond
         (= columns 6)
         [:div
          {:class (u/bem :flex-grid-group [:small :align-left])}
          (map
            (fn [product]
              [:div
               {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 :l-1-6])}
               (cards/product-card-default app-atom product {:small? true})])
            products)

          (when show-viewmore-link?
            [:div
             {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 :l-1-6])}
             (cards/more-card {:url more-url :text "more"})])]

         :else
         [:div
          {:class (u/bem :flex-grid-group [:small :align-left])}
          (map
            (fn [product]
              [:div
               {:class (u/bem :flex-grid-block [:small :t-1-2 :ml-1-3 (keyword (str "l-1-" columns))])}
               (cards/product-card-default app-atom product {})])
            products)]))
     (when
       (and
         (< columns 6)
         show-viewmore-link?)
       [:div.u-margin-top-16
        {:class (u/bem :flex-grid-group [:m-align-right])}
        [:div.u-min-width-240
         {:class (u/bem :flex-grid-block [:fluid])}
         [:div.flex-grid-content
          (buttons/button-web "View more"
            {:type :button
             :href more-url
             :full true
             :icon :arrow-right
             :icon-placement :right})]]])]))
